import { createBrowserRouter, Navigate } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import AdminLayout from './pages/admin/layout';
import LoginPage from './pages/login/page';
import ForgotPasswordPage from './pages/forgot-password/page';
import ResetPasswordPage from './pages/reset-password/page';
import HomePage from './pages/page';
import ErrorPage from './__error';
import Root from './__root';
import DriversPage from './pages/admin/drivers/page';
import DriverCreatePage from './pages/admin/drivers/new/page';
import DriverDetailsPage from './pages/admin/drivers/[id]/page';
import CompaniesPage from './pages/admin/companies/page';
import CompanyCreatePage from './pages/admin/companies/new/page';
import CompanyDetailsPage from './pages/admin/companies/[id]/page';
import CustomersPage from './pages/admin/customers/page';
import CustomerDetailsPage from './pages/admin/customers/[id]/page';
import SupportPage from './pages/admin/support/page';
import RidesPage from './pages/admin/rides/page';
import RideDetailsPage from './pages/admin/rides/[id]/page';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '',
        element: <HomePage />,
      },
      {
        path: 'login',
        element: (
          <AuthGuard shouldBeAuthenticated={false}>
            <LoginPage />
          </AuthGuard>
        ),
      },
      {
        path: 'forgot-password',
        element: (
          <AuthGuard shouldBeAuthenticated={false}>
            <ForgotPasswordPage />
          </AuthGuard>
        ),
      },
      {
        path: 'reset-password',
        element: (
          <AuthGuard shouldBeAuthenticated={false}>
            <ResetPasswordPage />
          </AuthGuard>
        ),
      },
      {
        path: 'admin',
        element: (
          <AuthGuard>
            <AdminLayout />
          </AuthGuard>
        ),
        children: [
          { path: '', element: <Navigate to="/admin/drivers" replace /> },
          { path: 'drivers', element: <DriversPage /> },
          { path: 'drivers/new', element: <DriverCreatePage /> },
          { path: 'drivers/:id', element: <DriverDetailsPage /> },

          { path: 'companies', element: <CompaniesPage /> },
          { path: 'companies/new', element: <CompanyCreatePage /> },
          { path: 'companies/:id', element: <CompanyDetailsPage /> },

          { path: 'customers', element: <CustomersPage /> },
          { path: 'customers/:id', element: <CustomerDetailsPage /> },

          { path: 'support', element: <SupportPage /> },

          { path: 'rides', element: <RidesPage /> },
          { path: 'rides/:id', element: <RideDetailsPage /> },
        ],
      },
    ],
  },
]);
